import { render, staticRenderFns } from "./Isracard.vue?vue&type=template&id=0252bd04&scoped=true&"
import script from "./Isracard.vue?vue&type=script&lang=js&"
export * from "./Isracard.vue?vue&type=script&lang=js&"
import style0 from "./Isracard.vue?vue&type=style&index=0&id=0252bd04&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0252bd04",
  null
  
)

export default component.exports